import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-submit"
//
// Submits as soon as the input changes, so file pickers and drop targets do
// not need a separate submit button.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
